import * as types from './types';

export default (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_SUCCEEDED:
      return action.payload.response.data;
    default:
      return state;
  }
}

export const getUpcomingCycle = (state) => state.upcoming;
export const getCurrentCycle = (state) => state.current;
